<template>
  <div class='MakeCardCheck'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:cardNature="{ item }">
        <span>{{ $label.getLabel($label.CardTypes, item.cardNature) }}</span>
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>

  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import { optionsDataReplace } from '@/utils'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },
      search: { // 搜索
        searchData: {}, // 返回的数据
        searchForm: [
          { type: 'Input', label: '卡名称：', prop: 'cardName', placeholder: '请输入卡名称' },
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', width: '180px', options: [], props: this.$map.typeProps, change: row => '', placeholder: '请选择卡类型' },
          { type: 'Date', label: '有效期：', prop: 'validPeriod', placeholder: '请选择有效日期' },
          { type: 'Input', label: '批次号：', prop: 'batchSn', placeholder: '请输入批次号' },
          { type: 'Date', label: '入库日期：', prop: 'inboundDate', placeholder: '请选择更新日期' },
          { type: 'Input', label: '入库人员：', prop: 'inboundUser', placeholder: '请输入入库人员' },
          { type: 'Input', label: '入库序列ID：', prop: 'inboundSn', placeholder: '请输入入库序列ID' }
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },

      Table: { // 表格
        selectionHandle: (v) => this.selectionHandle(v),
        primaryBtn: {
          show: true,
          html: '审核',
          handle: (el) => this.checkEvent(el)
        },
        selectedList: [], // 选中的list
        data: [],
        column: [
          { type: 'selection' },
          { prop: 'batchSn', label: '批次号' },
          { prop: 'cardNature', label: '卡种类', slot: true },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'cardNo', label: '卡号' },
          { prop: 'remaining', label: '余额' },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'denomination', label: '面值(元)' },
          { prop: 'validPeriod', label: '有效期' },
          { prop: 'stateText', label: '卡状态' },
          { prop: 'inboundTime', label: '入库日期' },
          { prop: 'inboundSn', label: '入库序列ID' },
          { prop: 'inboundUserName', label: '入库人员' }
        ]
      },

      listDialog: { // 适用店铺
        show: false,
        title: '店铺',
        confirm: () => {
          this.listDialog.show = false
        },
        shopData: [] // 店铺数据
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    searchHandleForm () {
      this.pager.page = 1
      this.pager.rows = 10
      this.getItemList()
    },
    searchResetForm () {
      this.search.searchData = {}
    },

    getItemList () { // 获取列表
      const { pager, search, Table } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
      this.$http.getStoreCardExamListApi(params)
        .then((res) => {
          if (res.status === 200) {
            pager.count = res?.data?.total || 0
            Table.data = (res?.data?.list || []).map((item) => ({
              ...item,
              stateText: item.state.text,
            }))
          }
        })
    },
    // 点击审核
    checkEvent (el) {
      if (this.Table.selectedList.length === 0) return
      let ids = Array.from(new Set(this.Table.selectedList.map((item) => item.id)))
      ids = ids.join(',')
      this.approvalCardBatch({ ids }, el)
    },

    selectionHandle (v) {
      this.Table.selectedList = v
    },

    // 审核接口
    approvalCardBatch (param, el) {
      this.$http.examStoreCardApi(param)
        .then(res => {
          if (res.status === 200) {
            el.clearSelection()
            this.$message.success(res.msg)
            this.getItemList()
          }
        })
    },
    // 卡类型
    async getCardTypeList () {
      const res = await this.$http.getCardTypeList()
      if(res && res.status === 200) {
        this.typeOptions = res.data
        optionsDataReplace('cardTypeId', this.search.searchForm, (res.data || []))
      }
    },
    // 初始化
    init () {
      this.getItemList()
      this.getCardTypeList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
  .el-checkbox {
    width: 25%;
    margin-right: 0;
    &:nth-child(n + 4) {
      margin-top: 20px;
    }
  }
}
</style>
